/* eslint-disable array-bracket-newline */
/**
 * Implements MyPositions based on covalent api
 */
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import LimitOrdersTable from './Table';
import { IStore } from '../../../reducers';
import useCollectIcons from '../useCollectTokens';

/**
 * Parent component used to load tickers before renderings
 * @param props
 */
const LimitOrdersDataLayer = ({ width }: { width: number }) => {
  const loading = useSelector((state: IStore) => state.limit_orders.loading);
  const orders = useSelector((state: IStore) => state.limit_orders.orders);
  const tickers = useSelector((state: IStore) => state.limit_orders.tickers);
  const timezone = useSelector((state: IStore) => state.timezone.current);

  const [filter, setFilter] = useState('');

  const { tokens } = useCollectIcons(orders);

  const data = useMemo(
    () =>
      orders.filter((order) =>
        filter ? filter === `${order.chain}-${order.pair}` : true
      ),
    [orders, filter]
  );

  return (
    <LimitOrdersTable
      tickers={tickers}
      orders={data}
      tokens={tokens}
      filter={filter}
      timezone={timezone}
      onFilter={setFilter}
      loading={loading}
      width={width}
    />
  );
};

export default LimitOrdersDataLayer;
